import { Link } from 'gatsby';
import React from 'react';
import { isDev } from '../../config';
import User from './user/User';
import SiteMessage from './SiteMessage';

const RELEASE_VERSION = process.env.GATSBY_RELEASE_SHA;

const Banner = () => (
  <>
    <div className="site-banner">
      {isDev() && (
        <div className="cell small-12 callout warning">
          <strong>
            You are viewing a development version of this site.{' '}
            <a
              style={{ color: 'blue', textDecoration: 'underline' }}
              href="https://mountainvalleygrowers.com"
            >
              Click here to go to the production site.
            </a>
          </strong>
          <br />
          {RELEASE_VERSION ? <i>Version: {RELEASE_VERSION}</i> : null}
        </div>
      )}
      <div className="grid-container">
        <div className="top-bar">
          <div className="top-bar-left">
            <nav aria-label="Site switcher">
              <ul className="menu">
                <li
                  className="current-item site-tab mvg"
                  aria-current="page"
                >
                  <Link to="/">Mountain Valley Growers</Link>
                </li>
                <li className="site-tab plugtrays">
                  <a href="https://www.plugtrays.com">Organic Plug Trays</a>
                </li>
              </ul>
            </nav>
          </div>
          <div className="top-bar-right">
            <User />
          </div>
        </div>
      </div>
    </div>
    <SiteMessage />
  </>
);

export default Banner;
